import { useEffect } from "react";

export const Seo = ({ title, description }) => {
  useEffect(() => {
    document.title = title;
    const set = (attr, key, content) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    set("name", "description", description);
    set("property", "og:title", title);
    set("property", "og:description", description);
    set("property", "og:site_name", "Antelli");
    set("property", "og:type", "website");
  }, [title, description]);
  return null;
};
